import PropTypes from 'prop-types';
import { Badge, Dropdown, Icon, IconButton } from '@openedx/paragon';
import {
  RiBox3Line, RiBugLine, RiMore2Fill, RiQuestionLine,
} from '@remixicon/react';
import { useIntl } from '@edx/frontend-platform/i18n';

import {
  formatTicketShortId,
  formatTimeAgo,
  getStatusBadgeColor,
  getStatusLabel,
  getTypeIconColor,
  getTypeLabel,
} from '../utils';
import messages from '../messages';

const TYPE_ICONS = {
  bug: RiBugLine,
  issue: RiQuestionLine,
  feature: RiBox3Line,
  other: RiBox3Line,
};

const TicketHeader = ({ ticket, onDelete }) => {
  const intl = useIntl();
  const TypeIcon = TYPE_ICONS[(ticket.type || '').toLowerCase()] || RiBox3Line;

  return (
    <section className="learner-support-view__card learner-support-view__ticket-card">
      <div className="learner-support-view__ticket-top">
        <span className="learner-support-view__ticket-id">
          {formatTicketShortId(ticket.id)}
        </span>
        <div className="learner-support-view__ticket-top-actions">
          <Badge variant="soft" color={getStatusBadgeColor(ticket.status)}>
            {getStatusLabel(ticket.status, intl, messages)}
          </Badge>
          {onDelete && (
            <Dropdown drop="start">
              <Dropdown.Toggle
                as={IconButton}
                src={RiMore2Fill}
                iconAs={Icon}
                alt={intl.formatMessage(messages.rowMenu)}
                variant="ghost-secondary"
                size="sm"
                id={`ticket-header-actions-${ticket.id}`}
              />
              <Dropdown.Menu>
                <Dropdown.Item onClick={() => onDelete(ticket)}>
                  {intl.formatMessage(messages.delete)}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          )}
        </div>
      </div>

      <h2 className="learner-support-view__title">{ticket.title}</h2>

      <div className="learner-support-view__meta-row">
        {ticket.type && (
          <span
            className="learner-support-view__meta-pill"
            style={{ color: getTypeIconColor(ticket.type) }}
          >
            <Icon src={TypeIcon} size="sm" />
            <span className="learner-support-view__meta-pill-text">
              {getTypeLabel(ticket.type, intl, messages)}
            </span>
          </span>
        )}
        {ticket.updatedAt && (
          <span className="learner-support-view__meta-item">
            {intl.formatMessage(messages.ticketUpdatedMeta, {
              time: formatTimeAgo(ticket.updatedAt, intl.locale),
            })}
          </span>
        )}
      </div>
    </section>
  );
};

TicketHeader.propTypes = {
  ticket: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string,
    status: PropTypes.string,
    type: PropTypes.string,
    createdAt: PropTypes.string,
    updatedAt: PropTypes.string,
  }).isRequired,
  onDelete: PropTypes.func,
};

TicketHeader.defaultProps = {
  onDelete: undefined,
};

export default TicketHeader;
